<template>
    <section class="margin-both-lg container container--medium">
        <div class="inner">
            <h2 v-if="data.title" class="titler margin-bottom-md jost jost--35  text-center font--700">{{data.title}}</h2>
            <div v-if="data.links" class="links-list">
                <template v-for="({link}, k) in data.links">
                    <Button :key="k" class="color-link venue-btn " type="green" link hasIcon :outlined="false">
                        <AcfLink  :data="link" />
                        <span class="icon">
                            <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg"><defs><path d="M15.653 15.182a1.274 1.274 0 011.818 0c.491.509.491 1.31 0 1.818l-7.618 7.619a1.305 1.305 0 01-.926.381 1.31 1.31 0 01-.928-.381L.38 17a1.274 1.274 0 010-1.818 1.274 1.274 0 011.818 0l5.437 5.455V1.273A1.279 1.279 0 018.926 0c.709 0 1.272.564 1.272 1.273v19.363l5.455-5.454z" transform="rotate(-90 10.71 10.71)" id="a"/></defs><path d="M15.182 5.767a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L17 21.038a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H1.272A1.279 1.279 0 010 12.494c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#143D54" fill-rule="evenodd"/></svg>
                        </span>
                    </Button>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import Button from '@/components/elements/Button'
import AcfLink from '@/components/elements/AcfLink'

export default {
    name: 'links',
    props: ['data'],
    computed:{
        
    },
    methods:{
        linkType(link){
            const home = window.WPVUE.home
            return link.includes(home) ? 'link' : 'external'
        }
    },
    components:{
        Button,
        AcfLink
    },
};
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.module-links{
    .inner{
        max-width: 800px;
        margin: 0 auto;
    }
    .titler{
        margin-top: 0;
    }
    .color-link, .fill-button{
        display: block;
        width: 100%;

    }
    .color-link{
        margin-bottom: 15px;
        &:last-child{
            margin-bottom: 0;
        }
    }
    
}
</style>